import React, { Component } from 'react';
import { createMuiTheme,
  MuiThemeProvider,withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";
import customStyle from '../../Assets/CSS/stylesheet_UHS';
import configurations from "../../configurations";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Tooltip from '@material-ui/core/Tooltip';
import styles from "../../Assets/CSS/stylesheet_UHS";
import LocationOffIcon from '@material-ui/icons/LocationOff';
import CallMadeIcon from '@material-ui/icons/CallMade';
import axios from "axios";
import AIKB from './AIKB';
import { Modal } from 'react-bootstrap';
import SecureVideoPlayer from './SecureVideoPlayer/SecureVideoPlayer';


const CustomButton = withStyles(
  customStyle.viewBtn
)(Button);

const StyleTooltip = withStyles({
  tooltip: {
    color: "grey",
    backgroundColor: "#ffffff",
    fontSize:'13px'
  }
})(Tooltip);


const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    padding:'0px',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const NextButton = withStyles(
    customStyle.doneBtn
)(Button);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    paddingLeft:'16px',
    paddingRight:'0px',
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

// export default function CustomizedAccordions() {
//   const [expanded, setExpanded] = React.useState('panel1');

//   const handleChange = (panel) => (event, newExpanded) => {
//     setExpanded(newExpanded ? panel : false);
//   };
class CustomizedAccordions extends Component{
    constructor(props){
        super(props)
        this.state = {
            expanded: 'panel2',
            accordionData:[],
            agentURL: '',
            tooltipShow:false,
            showStates: false,
            videoLink: null,
            resourceLinkURL: process.env.REACT_APP_resourceLinkURL,
            findInLink: process.env.REACT_APP_findInLink,
            isManageEmployersPath: window.location.pathname.includes('/manage-employers')
        }
    }

    componentDidMount(){
      window.addEventListener('message', (event) => {
        // Validate the origin of the message for security (make sure the message is coming from the expected source)
        if (event.origin !== configurations.enrollmentURL) {
          console.log("Origin not allowed:", event.origin);
          return;
        }
        const messageData = event.data;
        if(messageData.QuoteQuoteAcesss){
          const messageData = { details: 'Agent', agentID: this.props.agentId, employerFlow: sessionStorage.getItem("EMPLOYER_FLOW") };
          event.source.postMessage(messageData, event.origin);
        }
        if (messageData.status === 'quote_loaded') {
          console.log(`Quote ID: ${messageData.quoteID} has been loaded.`);
        }
      });

        let data = {
            "clientId" : this.props.clientId
        }
        axios.post(configurations.baseUrl + '/enrollment/getClient', data)
            .then(response=>{
                if(response.data.response){
                    let clientName = response.data.response.clientName.replaceAll(' ', '');
                    let url = configurations.AGENT_BASE_URL + clientName + '/' + this.props.agentId
                        if(this.props.empid){
                            url  = url + '/' + this.props.empid
                        }
                    this.setState({
                        agentURL :  url
                    })

                }
            });


      fetch(configurations.baseUrl + '/agentlogin/organizationDocList/' + this.props.clientId)
      .then(response => response.json())
      .then(data => {
              this.setState({accordionData:data.response})
      });

      fetch(configurations.baseUrl + '/employer/employerOrganizationDocList')
      .then(response => response.json())
      .then(data => {
        this.setState({ accordionDataEmployer: data.response.learningList[0]?.data })
      });

      axios.get(configurations.baseUrl + "/agentlogin/getAgentById/" + this.props.agentId)
        .then((response) => {
          console.log("desc===", response)
          if (response.data.response) {
            this.setState({
              agent: response.data.response,
              loaderShow: false,
            }, () => {
              this.state.agentEmail = this.state.agent.email
              this.state.agentPhone = this.state.agent.phone
            });

            let obj = {
              clientId: response.data.response.clientName,
              associationId: response.data.response.associationId,
              brokerId: response.data.response.brokerId,
              empid: this.props.empid,
              agentName: this.state.agent.firstName + " " + this.state.agent.lastName,
              agentEmail: this.state.agentEmail,
              agentPhone: this.state.agentPhone,
              channelName: response.data.response.clientName,
              fromAgent: true
            };

            axios.post(configurations.baseUrl + "/encrypt/encryptData", obj)
              .then((response) => {
                let quick_quote_url =
                  configurations.enrollmentURL +
                  "/quick_quote" +
                  "#state=" +
                  response.data.response;

                let enrollment_url = configurations.enrollmentURL +
                  "/signup" +
                  "#state=" +
                  response.data.response;
                this.setState({
                  loaderShow: false,
                  quick_quote_url: quick_quote_url,
                  enrollment_url: enrollment_url
                });
              });
          }
        });

      axios.get(process.env.REACT_APP_enrollment_base_url + '/enrollment/blacklisted-states')
        .then(response => {
          this.setState({ blackListedStates: response.data.response })
        })
    }
    handleChange =  panel => (event, expanded) =>{
        this.setState({expanded:expanded ? panel : false})
    }

    copy = (e) => {
        if(this.state.agentURL !== ''){
           // this.state.agentURL.select();
            document.execCommand("copy");
            e.target.focus();
            this.setState({ tooltipShow:true});
            this.hideTooltip()
        }
    }

    hideTooltip=()=>{
      setInterval(() => { 
        this.setState({
          tooltipShow:false
        })
        }, 5000);
    }

    linkClick = (url, isOn) => {
      if (!isOn || !this.props.disable) {
        const childWindow = window.open(url, '_blank');
        if(url.includes("quick_quote")){
            const messageData = { details: 'Agent', agentID: this.props.agentId, employerFlow: sessionStorage.getItem("EMPLOYER_FLOW") };
            setTimeout(() => {
              if (childWindow && !childWindow.closed) {
                childWindow.postMessage(messageData, configurations.enrollmentURL); // Ensure this URL is the same origin
              } else {
                console.log("Child window is closed or not opened.");
              }
            }, 1000);
        }
      }
    };

    render(){

        /*let dataarray=this.state.accordionData.map((value,i)=>{
            return <div style={{boxSizing:'content-box'}} key={i}>
                <div style={{display : 'inline-flex', width : '100%'}}>
                    {/!*{
                        i === 6 ?
                            <div style={{width : '13%'}}>
                                <svg width="40px" height="40px" viewBox="0 0 16 16" className="bi bi-box-arrow-up-right" fill="#dee2e6" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" d="M1.5 13A1.5 1.5 0 0 0 3 14.5h8a1.5 1.5 0 0 0 1.5-1.5V9a.5.5 0 0 0-1 0v4a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 0 0-1H3A1.5 1.5 0 0 0 1.5 5v8zm7-11a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.5H9a.5.5 0 0 1-.5-.5z"/>
                                    <path fillRule="evenodd" d="M14.354 1.646a.5.5 0 0 1 0 .708l-8 8a.5.5 0 0 1-.708-.708l8-8a.5.5 0 0 1 .708 0z"/></svg>
                            </div>

                            :
                            <div style={{width : '13%'}}>
                                <a href={value.docLink} style={{textDecoration:'none',color:'rgba(0, 0, 0, 0.87)',cursor:'pointer'}} target='_blank' download>
                                    <svg width="40px" height="40px" viewBox="0 0 16 16" className="bi bi-download" fill="#eb5757" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" d="M.5 8a.5.5 0 0 1 .5.5V12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8.5a.5.5 0 0 1 1 0V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8.5A.5.5 0 0 1 .5 8z"/>
                                        <path fillRule="evenodd" d="M5 7.5a.5.5 0 0 1 .707 0L8 9.793 10.293 7.5a.5.5 0 1 1 .707.707l-2.646 2.647a.5.5 0 0 1-.708 0L5 8.207A.5.5 0 0 1 5 7.5z"/>
                                        <path fillRule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0v-8A.5.5 0 0 1 8 1z"/>
                                    </svg></a>
                            </div>
                    }*!/}
                    <div style={{width : '80%', marginTop : '5px'}}>
                        <span style={customStyle.marketingAgent}>{value.title}</span>
                    </div>
                </div>

              {/!*{i === 0
                  ?
                  <span style={customStyle.marketingValue}>{value.description}</span>:<span style={customStyle.marketingValue}>{value.description}</span>}*!/}
            </div>
        })*/
      return (
        <div style={{fontFamily: "Roboto, Arial, Helvetica, sans-serif"}}>
            {/* <StyleTooltip title="Copied to clipboard !" open={this.state.tooltipShow} onClose={this.hideTooltip} placement='top' disableHoverListener>
                  <CopyToClipboard text={this.state.agentURL}>
                    <NextButton style={{width:'100%',fontWeight:'bold', height : 'auto',marginBottom:'8px', marginTop : '0', fontSize : '16px'}} disabled={this.state.agentURL !== '' && this.props.disable}  onClick={(e) => this.copy(e)}>{this.props.empName ? "COPY MY PAGE LINK FOR " + this.props.empName : "COPY MY PAGE LINK"} </NextButton>
                 </CopyToClipboard>
              </StyleTooltip> */}
              <div style={customStyle.linksContainer}>
                <div style={customStyle.labelContainer}>
                  <text>QUICK LINKS</text>
                </div>
                <div style={customStyle.inputContainer}>
                  {process.env.REACT_APP_PORTAL !== 'employer' && (
                    <>
                  <div style={this.props.disable ? customStyle.linksButtonD : customStyle.linksButton} onClick={() => this.linkClick(this.state.quick_quote_url, true)} disabled={this.props.disable}>
                    <text>QUICK QUOTE</text>
                  </div>
                  <div style={this.props.disable || this.state.isManageEmployersPath ? customStyle.linksButtonD : customStyle.linksButton} onClick={() => this.state.isManageEmployersPath ? () => {}: this.linkClick(this.state.enrollment_url, true)} disabled={this.state.agentURL !== '' && this.props.disable}>
                    <text>ENROLLMENT</text>
                  </div>
                  <div style={this.props.disable ? customStyle.linksButtonD : customStyle.linksButton} onClick={() => this.linkClick(this.state.agentURL, true)} disabled={this.props.disable}>
                    <text>MY PAGE</text>
                  </div>
                    </>
                  )}
                  <div style={this.props.disable ? customStyle.linksButtonD : customStyle.linksButton} onClick={() => this.setState({showStates: true})} disabled={this.props.disable}>
                    <text>EXCLUDED STATES</text>
                  </div>
                  <div style={this.props.disable ? customStyle.linksButtonD : customStyle.linksButton} onClick={() => this.linkClick(this.state.findInLink, true)} disabled={this.state.agentURL !== '' && this.props.disable}>
                    <text>FIND IN-NETWORK PROVIDERS</text>
                  </div>
                  <div style={this.props.disable ? customStyle.linksButtonD : customStyle.linksButton} onClick={() => this.linkClick(this.state.resourceLinkURL, true)} disabled={this.props.disable}>
                    <text>AGENT RESOURCE CENTER</text>
                  </div>
                </div>
                <br/>
                {/* <AIKB/> */}
              </div>
            
              {/* {(this.state.accordionData && this.state.accordionData.Learning && this.state.accordionData.Learning.length > 0) && this.props.clientId.toString() != '5742' && this.props.clientId.toString() != '4599' ? <Accordion expanded={this.state.expanded === 'panel3'}  onChange={this.handleChange('panel3')}>
                <AccordionSummary expandIcon={<ExpandMoreIcon style={{color: "#fff"}}/>} aria-controls="panel3d-content" id="panel3d-header" style={{backgroundColor:'#8283be'}}>
                    <Typography style={customStyle.accordioanLabelTop}>Learning Resources</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid item xs={6} sm={6} lg={12}>
                        { (this.state.accordionData && this.state.accordionData.Learning) &&
                        this.state.accordionData.Learning.map((op,index) => (
                            <Typography onClick={() => op.type === "Learning_Video" ? this.setState({videoLink: op}) : window.open(op.docLink)} key={index + 'ul'} component={'ul'} style={{paddingLeft : '10px', margin : '5px', cursor: "pointer"}} >
                               <img src={require(`../../Assets/Images/${op.type === "Learning_Video" ? 'PlayCircleOutlineIcon.png' : 'downloadIcon.png'}`)} width={25} style={{marginRight:10}}/>  
                                <a style={{textDecoration:'none',color:'rgba(0, 0, 0, 0.87)',cursor:'pointer', marginRight : '7px', fontFamily: "Roboto, Arial, Helvetica, sans-serif", fontSize : '14px'}} target='_blank'>
                                    {op.title}
                                </a>
                            </Typography>
                        ))
                        }
                    </Grid>
                </AccordionDetails>
            </Accordion>:<></>} */}
            {/* <Accordion expanded={this.state.expanded === 'panel1'}  onChange={this.handleChange('panel1')} >
                <AccordionSummary expandIcon={<ExpandMoreIcon style={{color: "#fff"}}/>} aria-controls="panel1d-content" id="panel1d-header" style={{backgroundColor:'#8283be'}}>
                    <Typography style={customStyle.accordioanLabelTop}>Agent Resources</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid item xs={6} sm={6} lg={12}>
                      <Typography component={'ul'} style={{ paddingLeft: '10px', margin: '5px' }}>
                      <LocationOffIcon  width={25} style={{marginRight:10, color: "#3c388f"}}/>  
                        <a onClick={() => this.setState({ showStates: true })} style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)', cursor: 'pointer', marginRight: '7px', fontFamily: "Roboto, Arial, Helvetica, sans-serif", fontSize: '14px' }} target='_blank'>
                          Excluded States
                        </a>
                      </Typography>
                        { (this.state.accordionData && this.state.accordionData.Sales) &&
                        this.state.accordionData.Sales.map((op,index) => (
                            <Typography component={'ul'} style={{paddingLeft : '10px', margin : '5px'}} onClick={() => window.open(op.docLink)} key={index + 'ul'}>
                            {op.description && op.description === "link" ? <CallMadeIcon width={25} style={{marginRight:10, color: "#3c388f"}}/>  :  <img src={require("../../Assets/Images/downloadIcon.png")} width={25} style={{marginRight:10}}/>  }
                                <a style={{textDecoration:'none',color:'rgba(0, 0, 0, 0.87)',cursor:'pointer', marginRight : '7px', fontFamily: "Roboto, Arial, Helvetica, sans-serif", fontSize : '14px'}} target='_blank'>
                                    {op.title}
                                </a>
                            </Typography>
                        ))}
                    </Grid>
                </AccordionDetails>
            </Accordion> */}
            {/* <Accordion square expanded={this.state.expanded === 'panel2'} onChange={this.handleChange('panel2')} >
            <AccordionSummary expandIcon={<ExpandMoreIcon style={{color: "#fff"}}/>} aria-controls="panel2d-content" id="panel2d-header" style={{backgroundColor:'#8283be'}}>
              <Typography component={'span'} style={customStyle.accordioanLabelTop}>Member & Prospect Resources</Typography>
            </AccordionSummary>
            <AccordionDetails style={{overflowY : 'auto', marginBottom: 30}}>
                <Grid item xs={6} sm={12} lg={12}>
                    { (this.state.accordionData && this.state.accordionData.MarketingList) &&
                    this.state.accordionData.MarketingList.map((op,index) => (
                        <Typography key={'newL' + index} component={'ul'} style={{ listStyleType: "none", paddingLeft : '0px', fontFamily: "Roboto, Arial, Helvetica, sans-serif", fontSize : '14px' }}>
                            <span key={index} style={customStyle.accordioanLabel}>{op.Header}</span>
                            {
                                op.data.map((key, index) => (
                                    <Typography component={'li'} style={{paddingLeft : '10px', margin : '5px'}}>
                                         <img src={require("../../Assets/Images/downloadIcon.png")} width={20} style={{marginRight:10}}/>  
                                       <a href={key.docLink} style={{textDecoration:'none',color:'rgba(0, 0, 0, 0.87)',cursor:'pointer', marginRight : '7px', fontFamily: "Roboto, Arial, Helvetica, sans-serif", fontSize : '14px'}} target='_blank'>
                                        {key.title}
                                       </a>
                                       
                                    </Typography>
                                ))
                            }
                            <br/>
                        </Typography>
                        
                    ))}
                </Grid>                

            </AccordionDetails>
          </Accordion> */}
          {(this.state.accordionData && this.state.accordionData.NoticeList && this.state.accordionData.NoticeList && process.env.REACT_APP_PORTAL !== 'employer') ?
          <div>
                <div aria-controls="panel3d-content" id="panel3d-header" style={{backgroundColor:'#8283be'}}>
                    <h3 style={customStyle.accordioanLabelTop}>Notices</h3>
                </div>
                <div>
                    <Grid item xs={6} sm={6} lg={12}>
                        { (this.state.accordionData && this.state.accordionData.NoticeList) &&
                        this.state.accordionData.NoticeList.map((op,index) => (
                            <Typography key={index + 'ul'} component={'ul'} style={{paddingLeft : '10px', margin : '5px'}} >
                               <img src={require("../../Assets/Images/downloadIcon.png")} width={25} style={{marginRight:10}}/>  
                                <a href={op.docLink} style={{textDecoration:'none',color:'rgba(0, 0, 0, 0.87)',cursor:'pointer', marginRight : '7px', fontFamily: "Roboto, Arial, Helvetica, sans-serif", fontSize : '14px'}} target='_blank'>
                                    {op.title}
                                </a>
                            </Typography>
                        ))
                        }
                    </Grid>
                </div>
            </div>:<></>}

          {this.state.videoLink && <Modal size="lg" show={this.state.videoLink} onHide={(event) => this.setState({ videoLink: null})} centered>
          <Modal.Header style={customStyle.modal_header} closeButton>
            <Modal.Title> 
              {this.state.videoLink.title}  
              </Modal.Title>
            
            </Modal.Header>
            <Modal.Body style={{padding: 0}}>
                <SecureVideoPlayer
                     url={this.state.videoLink.docLink}
                     title={this.state.videoLink.title || ""}
                     onComplete={() => {}}
                   />
              </Modal.Body>
          </Modal>}
          <Modal size="md" show={this.state.showStates} onHide={(event) => this.setState({ showStates: false, loaderShow: false })} backdrop='static' centered>
            <Modal.Header style={customStyle.modal_header} closeButton>
              <Modal.Title>Excluded States</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '15px' }}>
              <ul>
                {
                  this.state?.blackListedStates?.map(state => (
                    <li>{state}</li>
                  ))
                }
              </ul>
            </Modal.Body>
            <Modal.Footer>
              <CustomButton style={{ height: '40px' }} onClick={() => this.setState({ showStates: false, loaderShow: false })}>Close</CustomButton>
            </Modal.Footer>
          </Modal>
        </div>
      );
    }
    }

export default CustomizedAccordions;